"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[596],{

/***/ 50596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgViviendaEstrenarCircle = function SvgViviendaEstrenarCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M22.94 11h-1.212a5.205 5.205 0 0 0-9.96-.827 4.154 4.154 0 0 0-1.602 7.964v4.946c0 .065.015.129.044.187l.833 1.666a.416.416 0 0 0 .668.109l1.666-1.667a.418.418 0 0 0 0-.59l-.538-.538.538-.539a.417.417 0 0 0 0-.589l-.538-.539.538-.538a.417.417 0 0 0 .122-.295v-1.613a4.166 4.166 0 0 0 1.23-.84 5.135 5.135 0 0 0 3.77.02v2.29A1.395 1.395 0 0 0 19.892 21h3.048a1.395 1.395 0 0 0 1.393-1.392v-7.216A1.394 1.394 0 0 0 22.94 11Zm-11.107 1.667c.508 0 .833.246.833.416 0 .17-.325.417-.833.417-.509 0-.834-.247-.834-.417 0-.17.325-.416.834-.416Zm1.11 4.795a.416.416 0 0 0-.277.392v1.723l-.711.712a.416.416 0 0 0 0 .589l.538.539-.538.538a.416.416 0 0 0 0 .59l.538.538-.963.964-.53-1.062v-5.131a.415.415 0 0 0-.278-.392 3.314 3.314 0 0 1 .794-6.43 5.22 5.22 0 0 0-.092.842c-.73.134-1.258.615-1.258 1.21 0 .7.732 1.25 1.667 1.25.934 0 1.666-.55 1.666-1.25 0-.588-.517-1.064-1.233-1.204.009-.278.044-.554.106-.825a3.317 3.317 0 0 1 .571 6.407Zm2.359-.84a4.125 4.125 0 0 0 .697-2.289 4.172 4.172 0 0 0-3.355-4.084A4.359 4.359 0 0 1 20.86 11h-.968a1.394 1.394 0 0 0-1.393 1.392v4.011c-1 .471-2.141.55-3.197.22Zm8.197 2.986a.56.56 0 0 1-.559.559h-3.048a.56.56 0 0 1-.56-.56v-7.215a.56.56 0 0 1 .56-.559h1.087c.003.07.02.137.02.209v.208a.416.416 0 1 0 .834 0v-.208c0-.07-.008-.14-.01-.209h1.117a.56.56 0 0 1 .56.56v7.215Z",
    fill: "CurrentColor"
  })), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#765346"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgViviendaEstrenarCircle);

/***/ })

}]);